<template>
  <div class="category-complete-component-container">
    <div class="heading">
      <h2
        v-if="categoryTypeId"
        class="title"
      >
        You've completed all categories in this category type!
      </h2>
      <h2
        v-else
        class="title"
      >
        You've Completed The {{ categoryName }} Category!
      </h2>
    </div>
    <div class="check" />
    <router-link
      v-if="categoryTypeId"
      to="home"
      class="button"
    >
      Return Home <span>→</span>
    </router-link>
    <router-link
      v-else
      :to="continueRoute"
      class="button"
    >
      Continue Studying <span>→</span>
    </router-link>
  </div>
</template>

<script>
import GlobalMixin from '@/mixins/global';

export default {
  mixins: [GlobalMixin],
  computed: {
    category() {
      return this.$store.getters['categories/categories'][this.$route.params.categoryId];
    },
    categoryTypeId() {
      return this.$route.params.categoryTypeId;
    },
    categoryType() {
      return this.$store.getters['categoryTypes/all'][this.categoryTypeId];
    },
    categoryName() {
      return this.category?.name || 'All';
    },
    continueRoute() {
      if (this.currentQuery.nav) {
        return { name: 'categories#index', query: this.currentQuery };
      } else {
        if (this.category.parentCategoryId) {
          return { name: 'categories#index', params: { categoryId: this.category.parentCategoryId }};
        }
        return { name: 'home' };
      }
    },
  },
  created() {
    if (this.$store.getters['session/onTour']) {
      this.$analytics.events.finishedOnboardingCategory(this.category.id);
      let route = {
        name: 'categories#index',
        params: this.$route.params,
        query: this.currentQuery,
      };
      this.$router.push(route);
    }
  },
};
</script>

<style lang='scss' scoped>
  $heading-color: $grey-2 !default;

  .category-complete-component-container {
    background: #EDF1F5;
    @include full-padding;

    .heading {
      color: $heading-color;
      font-size: rem-calc(18);
      font-weight: $semi-bold;
      margin-bottom: rem-calc(42);

      .title {
        text-align: center;
      }
    }

    .check {
      background-color: white;
      border-radius: 100%;
      @include correct-svg(#70CF63);
      height: rem-calc(100);
      margin: auto;
      width: rem-calc(100);
    }

    .button {
      align-items: center;
      background: white;
      border: 1px solid #E8E8E8;
      border-radius: 4px;
      color: #354052;
      cursor: pointer;
      display: block;
      font-size: rem-calc(18);
      font-weight: $semi-bold;
      margin: rem-calc(32) auto;
      padding: rem-calc(12);
      text-align: center;
      width: rem-calc(200);
    }
  }
</style>
